import type { Tables } from '../db/supabase.types.ts'
import { type ParsedAsset, type RawAsset } from '../assets/assetTypes.ts'

export type EventType = 'showing' | 'appraisal'

export type EventContact = {
  id: string
  name: string
  email?: string | null
  phone?: string | null
}

export type RawEvent = Tables<'events'> & {
  asset?: RawAsset | null
  event_contacts?: {
    contact: EventContact
  }[]
}

export type ParsedEvent = Omit<RawEvent, 'asset' | 'event_contacts'> & {
  asset?: ParsedAsset
  contacts?: EventContact[]
}
